import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect, useDispatch } from 'react-redux'
import { push } from 'react-router-redux'

import { allowAccessToRoute } from '../../utils/routes'

export function restrictAccess (Component) {
  const RestrictUserAccess = props => {
    const dispatch = useDispatch()

    const allowAccess = () => {
      const { user, route } = props
      return user && allowAccessToRoute(user, route.path)
    }

    useEffect(() => {
      if (!allowAccess()) {
        dispatch(push('/notfound'))
      }
    })

    return (
      <React.Fragment>
        {allowAccess()
          ? <Component {...props} />
          : null
        }
      </React.Fragment>
    )
  }

  RestrictUserAccess.propTypes = {
    user: PropTypes.object,
    route: PropTypes.object
  }

  const mapStateToProps = state => ({
    user: state.user.user
  })

  return connect(mapStateToProps)(RestrictUserAccess)
}



// WEBPACK FOOTER //
// ./src/containers/HOC/RestrictAccess.js